import type { NoodlNode } from '@shared/node-v1.0.0'
import { sendOutput, sendSignal } from '@shared/port-send-v1.0.0'
import type { Props, Store } from '../node/definition'

export const initStore = (p: Props) => ({}) satisfies Store

export default {
	reactive: (p: Props, noodlNode: NoodlNode) => {
		const navScheme = R.navigation
		if (navScheme) {
			const { subscribe } = R.libs.valtio
			const pageScheme = navScheme.scheme.find((i) => i.path === p.path)

			if (pageScheme) {
				if (pageScheme.page !== p.store.page) {
					p.store.page = pageScheme.page
					p.store.unsub?.()

					sendOutput(noodlNode, 'active', navScheme.page === pageScheme.page)
					sendOutput(noodlNode, 'params', navScheme.params)
					for (const param of pageScheme.params || []) {
						sendOutput(noodlNode, param, navScheme.params[param])
					}
					sendSignal(noodlNode, 'changed')

					p.store.unsub = subscribe(navScheme, () => {
						sendOutput(noodlNode, 'active', navScheme.page === pageScheme.page)
						sendOutput(noodlNode, 'params', navScheme.params)
						for (const param of pageScheme.params || []) {
							sendOutput(noodlNode, param, navScheme.params[param])
						}
						sendSignal(noodlNode, 'changed')
					})
				}
			}
		}
	},
}
